// hardwareStandards.js — VIENINTELIS furnitūros gręžimo standartų šaltinis.
// Anksčiau šios konstantos gyveno TIK View2D.jsx viduje (naudojamos elevacijos
// vaizde), o calculatePrice.js skaičiavo vyrių kiekį SAVO, kitokia riba
// (sideHingeCount: <0.8→2, <1.7→3, else→4). Dvi nesutampančios lentelės
// reiškė, kad kainos suvestinėje rodomas vyrių skaičius galėjo nesutapti su
// tuo, kas realiai piešiama brėžinyje tai pačiai durelei. Dabar abi vietos
// (View2D.jsx elevacija/gamybinis brėžinys IR calculatePrice.js kainodara)
// importuoja TĄ PATĮ hingeCountForHeight.
//
// Šaltinis — pramoninis Euro/32mm korpusinių baldų standartas (Hettich/Blum
// katalogai): lentynų kaiščių skylės Ø5mm, 32mm žingsniu, pirma/paskutinė
// skylė ~37mm nuo skydelio krašto. Durų vyrių tašelės Ø35mm, centras 22mm nuo
// durų krašto; vyrių kiekis priklauso nuo durų aukščio, pirma/paskutinė
// vyris ~100mm nuo durų viršaus/apačios.
export const WALL_THICKNESS = 0.018;

export const SHELF_PIN_PITCH = 0.032;
export const SHELF_PIN_MARGIN = 0.037;
export const SHELF_PIN_RADIUS = 0.012;

export const HINGE_CUP_RADIUS = 0.0175;
export const HINGE_CUP_INSET = 0.022;
export const HINGE_END_MARGIN = 0.10;

// Riba (cm): 0-80→2, 80-150→3, 150-200→4, 200-240→5, 240+→6 — patikslinta
// pagal ClickUp "2. Furnitūra. Lankstai. Šiek tiek atnaujinau taisyklę" lentelę
// (anksčiau buvo 90/160/220cm ribos, maks. 5 vyriai).
export const hingeCountForHeight = (h) => {
    if (h < 0.80) return 2;
    if (h < 1.50) return 3;
    if (h < 2.00) return 4;
    if (h < 2.40) return 5;
    return 6;
};

// ── Stalčių bėgelio ir vyrio tvirtinimo plokštelės VIETA (ne tiksli
// specifikacija) ──────────────────────────────────────────────────────────
// Gręžimas vyksta gamykloje pagal realiai užsakytą furnitūrą — šis
// dokumentas nurodo TIK zoną/vietą (žr. View2D.jsx DrillZoneH/DrillMark), ne
// tikslų varžtų žingsnį ar skaičių, tad čia laikoma tik viena reikšmė
// vietai, ne pilnas šablonas.
export const DRAWER_SLIDE_HOLE_MARGIN = 0.03;
export const DRAWER_SLIDE_HOLE_Y = 0.013;
export const HINGE_PLATE_HOLE_OFFSET = 0.037;
